import type { MessageKey } from '../i18n/en.ts';

/**
 * The "What's new" panel on the Docs page: one line per shipped change, newest first, in every language. Add a line
 * (and its three translations) in the PR that ships the change, so users learn about it inside the app.
 */
export const NEWS: readonly { date: string; key: MessageKey }[] = [
  { date: '2026-10-22', key: 'news.rates2' },
  { date: '2026-10-19', key: 'news.gov' },
  { date: '2026-10-19', key: 'news.price' },
  { date: '2026-10-19', key: 'news.rates' },
  { date: '2026-10-19', key: 'news.fee' },
  { date: '2026-10-19', key: 'news.catchUp' },
  { date: '2026-10-19', key: 'news.ranksLock' },
  { date: '2026-10-19', key: 'news.joinFirst' },
  { date: '2026-10-18', key: 'news.emblems' },
  { date: '2026-10-18', key: 'news.plans' },
  { date: '2026-10-17', key: 'news.staking' },
  { date: '2026-10-16', key: 'news.live' },
];
